module.exports = __webpack_public_path__ + "img/logo-mass.4e735fa5.png";